import {PluginObject} from 'vue';
import {Event, EventBus} from '@/plugins/bus';

const RolesPlugin: PluginObject<any> = {
  install(vue) {
    vue.mixin({
      data() {
        return {roleComputation: 1};
      },
      computed: {
        userIsSystemAdmin() {
          return this.roleComputation && this.$authService.checkRole('SystemAdmin');
        },
        userIsFleetManager() {
          return this.roleComputation && this.$authService.checkRole('FleetManager');
        },
        userIsWorkshopManager() {
          return this.roleComputation && this.$authService.checkRole('WorkshopManager');
        },
        userIsFleetOrWorkshopManager() {
          return this.roleComputation && (this.$authService.checkRole('FleetManager') || this.$authService.checkRole('WorkshopManager'));
        },
        userIsTechnician() {
          return this.roleComputation && this.$authService.checkRole('Technician');
        },
        userIsOperations() {
          return this.roleComputation && this.$authService.checkRole('Operations');
        },
        userIsDataEntry() {
          return this.roleComputation && this.$authService.checkRole('DataEntryClerk');
        },
      },
      methods: {
        userIsWorkshopManagerInGarage(id: string, garageIds: []) {
          const g = garageIds.find(x => x == id);
          return (this as any).userIsWorkshopManager && (g != undefined);
        },
        userIsOperationsInGarage(id: string, garageIds: []) {
          const g = garageIds.find(x => x == id);
          return (this as any).userIsOperations && (g != undefined);
        },
        userIsDataEntryInGarage(id: string, garageIds: []) {
          const g = garageIds.find(x => x == id);
          return (this as any).userIsDataEntry && (g != undefined);
        },
        recomputeRoles() {
          let me = this as any;
          me.roleComputation = me.roleComputation + 1;
        }
      },
      created() {
        let me = this as any;
        EventBus.$on(Event.UserAuthenticated, me.recomputeRoles);
      },
      destroyed() {
        let me = this as any;
        EventBus.$off(Event.UserAuthenticated, me.recomputeRoles);
      }
    });
  },
};

export default RolesPlugin;
